export interface OrganizationPollResponse {
  data: {
    organization: any;
    stories: any;
    users: any;
    payments: any;
    vehicleBrands: any;
    vehicleModels: any;
    productTemplates: any;
    products: any;
    discountTemplates: any;
    discounts: any;
    objects: any;
    logs: any;
    reports: any;
    etag: string;
  };
  id: number;
  done: boolean;
}

export interface OrganizationPollErrorResponse {
  text: string;
}

export enum OrganizationPollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
}

export enum OrganizationPollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
